import { render, staticRenderFns } from "./BacktestBollingerOptimizeView.vue?vue&type=template&id=1b40e0bc&scoped=true"
import script from "./BacktestBollingerOptimizeView.vue?vue&type=script&lang=js"
export * from "./BacktestBollingerOptimizeView.vue?vue&type=script&lang=js"
import style0 from "./BacktestBollingerOptimizeView.vue?vue&type=style&index=0&id=1b40e0bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b40e0bc",
  null
  
)

export default component.exports